import React from 'react';
import { withStyles } from '@material-ui/core';
import { AccessTime } from '@material-ui/icons';
import { primaryColor } from '../../assets/jss/appHealth.style';
import moment from 'moment';

const LinhaTempoPersonalizada = ({ classes, itens, filtrosSelecionados, isMaximized }) => {
  const calcularDiferencaTempo = (dataAtual, dataAnterior) => {
    const atual = moment(dataAtual);
    const anterior = moment(dataAnterior);
    const anos = atual.diff(anterior, 'years');
    const meses = atual.diff(anterior.add(anos, 'years'), 'months');
    const dias = atual.diff(anterior.add(anos, 'years').add(meses, 'months'), 'days');
    if (anos === 0 && meses === 0 && dias === 0) return '';
    
    const partes = [];
    if (anos > 0) partes.push(`${anos} ano${anos > 1 ? 's' : ''}`);
    if (meses > 0) partes.push(`${meses} m${meses !== 1 ? 'eses' : 'ês'}`);
    if (meses === 0 && dias > 0) partes.push(`${dias} dia${dias !== 1 ? 's' : ''}`);
    
    return partes.join(' e ');
  };
  const itensFiltrados = React.useMemo(() => {
    if (!filtrosSelecionados || filtrosSelecionados.length === 0 || !itens) return itens;
    
    return itens.filter(item => {
      return item.ner && item.ner.some(itemNer => 
        filtrosSelecionados.includes(itemNer.texto)
      );
    });
  }, [itens, filtrosSelecionados]);

  return (
    <div className={`${classes.timeline} ${isMaximized ? classes.timelineMaximized : ''}`}>
      {itensFiltrados && itensFiltrados.map((item, indice) => {
        const diferencaTempo = indice > 0 ? calcularDiferencaTempo(item.data_hora_lancamento, itensFiltrados[indice - 1].data_hora_lancamento) : '';
        
        const textoFinal = `${moment(item.data_hora_lancamento).format('DD/MM/YYYY')}${diferencaTempo ? ` - ${diferencaTempo} da última evolução` : ''}`;
        
        return (
          <div key={indice} className={classes.timelineItem}>
            <div className={classes.timelinePoint}>
              <div className={classes.radioButton}>
                <div className={classes.radioInner}></div>
              </div>
              {indice < itensFiltrados.length - 1 && <div className={classes.timelineLine}></div>}
            </div>
            <div className={classes.timelineContent}>
              <div className={classes.timelineHeader}>
                <h4 className={classes.timelineTitle}>{item.titulo}</h4>
                <div className={classes.entryInfo}>
                  <AccessTime className={classes.clockIcon} />
                  <span className={classes.entryText}>{textoFinal}</span>
                </div>
              </div>
              <p className={classes.timelineDescription}>{item.resumo}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

const styles = {
  timeline: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    overflowY: 'auto',
    maxHeight: '200px',
    padding: '10px'
  },
  timelineMaximized: {
    '@media (min-width: 1100px)': { maxHeight: '200px !important' },
    '@media (min-width: 1200px)': { maxHeight: '250px !important' },
    '@media (min-width: 1300px)': { maxHeight: '350px !important' },
    '@media (min-width: 1400px)': { maxHeight: '450px !important' },
    '@media (min-width: 1500px)': { maxHeight: '550px !important' },
    '@media (min-width: 1600px)': { maxHeight: '650px !important' },
    '@media (min-width: 1700px)': { maxHeight: '750px !important' },
    '@media (min-width: 1800px)': { maxHeight: '850px !important' },
    '@media (min-width: 1900px)': { maxHeight: '950px !important' },
    '@media (min-width: 2000px)': { maxHeight: '1050px !important' },
    '@media (min-width: 2100px)': { maxHeight: '1150px !important' },
    '@media (min-width: 2200px)': { maxHeight: '1250px !important' }
  },
  timelineItem: {
    display: 'flex',
    alignItems: 'flex-start',
    position: 'relative'
  },
  timelinePoint: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginRight: '15px'
  },
  radioButton: {
    width: '20px',
    height: '20px',
    borderRadius: '50%',
    border: `2px solid ${primaryColor}`,
    backgroundColor: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    zIndex: 2
  },
  radioInner: {
    width: '10px',
    height: '10px',
    borderRadius: '50%',
    backgroundColor: '#1E40AF'
  },
  timelineLine: {
    width: '2px',
    height: '80px',
    backgroundColor: primaryColor,
    marginTop: '5px'
  },
  timelineContent: {
    flex: 1,
    backgroundColor: 'transparent',
    padding: '15px',
    borderRadius: '8px',
    marginTop: '-2px',
    border: '1px solid #e0e0e0'
  },
  timelineHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '8px'
  },
  timelineTitle: {
    margin: 0,
    fontSize: '12px',
    fontWeight: 300,
    color: '#1E40AF',
    backgroundColor: '#BFDBFE',
    padding: '2px 12px',
    borderRadius: '15px',
    display: 'inline-block'
  },
  entryInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: '5px'
  },
  entryText: {
    fontSize: '12px',
    color: '#AEB8C4',
    fontWeight: 400
  },
  clockIcon: {
    fontSize: '14px',
    color: '#AEB8C4'
  },
  timelineDescription: {
    margin: 0,
    fontSize: '14px',
    color: '#666',
    lineHeight: '1.4'
  }
};

export default withStyles(styles)(LinhaTempoPersonalizada);